import InfoRestService from '../rest/InfoRestService'
import { saveAs } from 'file-saver'

class InfoService {
  static getVersions() {
    return InfoRestService.getVersions()
  }

  static async downloadHealthInfo() {
    try {
      const healthInfo = await InfoRestService.downloadHealthInfo()
      saveAs(healthInfo, 'GatewayDebugInfo.zip')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async downloadLogFile() {
    try {
      const logFile = await InfoRestService.downloadLogFile()
      saveAs(logFile, 'gateway.log')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static getDatabaseConfig() {
    return InfoRestService.getDatabaseConfig()
  }
}

export default InfoService
